import { render, staticRenderFns } from "./Preparatory.vue?vue&type=template&id=55404688&scoped=true&"
import script from "./Preparatory.vue?vue&type=script&lang=js&"
export * from "./Preparatory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55404688",
  null
  
)

export default component.exports